module.exports = "<app-accountmaster-menu></app-accountmaster-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/master-account/master-account.component.html
// module id = ./src/app/master-account/master-account.component.html
// module chunks = main